module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p24",
      "title": "24"
    }
  }, [_c('h2', {
    staticClass: "recipetitle",
    attrs: {
      "id": "caramel_sticky_rolls"
    }
  }, [_vm._v("Caramel Sticky Rolls")]), _vm._v(" "), _c('p', {
    staticClass: "recipetime"
  }, [_c('span', {
    staticClass: "yield_black"
  }, [_vm._v("15 rolls")]), _vm._v(" "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Prep Time: 40 Minutes "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Start to Finish: 3 Hours 20 Minutes")]), _vm._v(" "), _c('p', {
    staticClass: "dot"
  }, [_vm._v("•••")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient_head"
  }, [_vm._v("ROLLS")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient1"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("3½")]), _vm._v(" to 4 cups all-purpose or bread flour")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("⅓")]), _vm._v(" cup granulated sugar")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("2")]), _vm._v(" packages regular active or fast-acting dry yeast (4½ teaspoons)")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" cup very warm milk (120°F to 130°F)")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup butter, softened")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" egg")])]), _vm._v(" "), _c('p', {
    staticClass: "ingredient_head"
  }, [_vm._v("CARAMEL TOPPING")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient1"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" cup packed brown sugar")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("½")]), _vm._v(" cup butter, softened")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup light corn syrup")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" cup pecan halves, if desired")])]), _vm._v(" "), _c('p', {
    staticClass: "ingredient_head"
  }, [_vm._v("FILLING")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient1"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("½")]), _vm._v(" cup chopped pecans or raisins, if desired")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup granulated sugar or packed brown sugar")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" teaspoon ground cinnamon")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("2")]), _vm._v(" tablespoons butter, softened")])]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("1")]), _vm._v(" In large bowl, mix 2 cups of the flour, ⅓ cup granulated sugar, the salt and yeast. Add warm milk, ¼ cup butter and the egg. Beat with electric mixer on low speed 1 minute, scraping bowl frequently. Beat on medium speed 1 minute, scraping bowl frequently. Stir in enough remaining flour, ½ cup at a time, to make dough easy to handle.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("2")]), _vm._v(" Place dough on lightly floured surface. Knead about 5 minutes or until dough is smooth and springy. Grease large bowl with shortening. Place dough in bowl, turning dough to grease all sides. Cover bowl loosely with plastic wrap and let rise in warm place about 1 hour 30 minutes or until dough has doubled in size. Dough is ready if indentation remains when touched.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("3")]), _vm._v(" In 2-quart saucepan, heat brown sugar and ½ cup butter to boiling, stirring constantly; remove from heat. Stir in corn syrup. Pour into 13x9-inch pan. Sprinkle with pecan halves.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("4")]), _vm._v(" In small bowl, mix all filling ingredients except 2 tablespoons butter; set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("5")]), _vm._v(" Gently push fist into dough to deflate. On lightly floured surface, flatten dough with hands or rolling pin into 15x10-inch rectangle. Spread with 2 tablespoons butter; sprinkle with filling. Roll rectangle up tightly, beginning at 15-inch side. Pinch edge of dough into roll to seal. With fingers, shape until even. With dental floss or serrated knife, cut roll into 15 (1-inch) slices.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("6")]), _vm._v(" Place slices slightly apart in pan. Cover loosely with plastic wrap and let rise in warm place about 30 minutes or until dough has doubled in size.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("7")]), _vm._v(" Heat oven to 350°F. Uncover rolls. Bake 30 to 35 minutes or until golden brown. Let stand 2 to 3 minutes. Run metal spatula or knife around edge of pan to loosen rolls. Place heatproof serving plate upside down on pan; holding plate and pan with pot holders, turn plate and pan over together. Let stand 1 minute so caramel can drizzle over rolls; remove pan. Serve warm.")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p25",
      "title": "25"
    }
  }, [_c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("8")]), _vm._v(" To freeze, cool completely. Wrap tightly. Freeze up to 3 months. Thaw at room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_info"
  }, [_c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("1 Roll:")]), _vm._v(" Calories 320; Total Fat 12g (Saturated Fat 6g, Trans Fat 0.5g); Cholesterol 45mg; Sodium 250mg; Total Carbohydrate 50g (Dietary Fiber 1g); Protein 4g "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Exchanges:")]), _vm._v(" 1 Starch, 2½ Other Carbohydrate, 2 Fat "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Carbohydrate Choices:")]), _vm._v(" 3")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_variation"
  }, [_c('span', {
    staticClass: "variation_lead"
  }, [_vm._v("Cinnamon Rolls")]), _vm._v(" Omit caramel topping and pecan halves. Grease bottom and sides of 13x9-inch pan with shortening or cooking spray. Place dough slices slightly apart in pan. Let rise and bake as directed in Steps 6 and 7—except do not turn pan upside down. Remove rolls from pan to cooling rack. Cool 10 minutes. Drizzle rolls with vanilla glaze, if desired.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_note"
  }, [_c('span', {
    staticClass: "tips"
  }, [_vm._v("In a Flash")]), _vm._v(" Want to do some time shifting in the baking process? You can. After placing the slices in the pan, cover tightly with plastic wrap or foil; refrigerate 4 to 24 hours. About 2 hours before baking, remove from the refrigerator; remove the plastic wrap or foil and cover loosely with plastic wrap. Let rise in a warm place until the dough has doubled in size. If some rising has occurred in the refrigerator, rising time may be less than 2 hours. Bake as directed.")]), _vm._v(" "), _c('figure', {
    staticClass: "figure1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/p025.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "href": "#/html/p024"
    }
  }, [_vm._v("Caramel Sticky Rolls")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cd88f38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p024.vue
// module id = 120
// module chunks = 0